module.exports = __webpack_public_path__ + "static/media/failedLoad.e45f30e8.png";